module.exports = __webpack_public_path__ + "061a2387791bc8f8202bbcc32d1e4860.svg";